import React from 'react';
import {  TERMS } from '../assets/shared/termsConditions'
import useDataStore from '../store/dataStore';
const queryString = require("query-string")

function TermsConditionsComponent() {
    let us = queryString.parse(window.location.search).utm_source
    const data = useDataStore((state) => state.data);
    let Terms = TERMS[0];
    if(data.tnc.content[0]!==""){
        Terms = data.tnc;
    }

    console.log(Terms);
    

    let termsList = Terms.content.map((terms) => {
        const markup = { __html: terms }
        return (
            <p dangerouslySetInnerHTML={markup}>
            </p>
        );
    });

    return (
        <div className="">
            <h3>Terms And Conditions</h3>
            <h4>{Terms.heading}</h4>
            <div>{termsList}</div>
        </div>
    );
}

export default TermsConditionsComponent;